import React, { useMemo, useState } from 'react'

import { useGroups } from 'redux/hooks/Groups'
import { useNavigation } from 'redux/hooks/NavigationMenuStore'
import { useNavigationActions } from 'redux/actions/NavigationMenu'
import { useTranslation } from 'language/translator'

import NavigationMenu from 'components_new/molecules/NavigationMenu'
import { TNavigationItem } from 'components_new/molecules/NavigationItem'

import AddGroupDialog from 'components_new/organisms/dialogs/AddGroupDialog'
import { GROUPS_NAV_MENU_ID } from 'components_new/organisms/Navbar/lib'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

const ResourcesNavigation = () => {
  const [addDialogOpen, setAddGroupDialogOpen] = useState<boolean>(false)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { myGroups, loading } = useGroups()
  const { open, expandedItems } = useNavigation()
  const { toggleNavigationItem } = useNavigationActions()
  const { isAdmin } = useAccountSettings()

  const { t, lang } = useTranslation()

  const items: TNavigationItem[] = useMemo(() => {
    return [
      {
        activePattern: '/groups',
        icon: { name: 'Groups' } as const,
        href: '/groups',
        title: t('groups', 'all_groups')
      },
      ...myGroups.map((group) => ({
        activePattern: `/groups/${group.id}*`,
        avatar: {
          color: group.profile_color,
          title: group.name
        },
        href: `/groups/${group.id}`,
        title: group.name,
        titleIcon: group.is_private
          ? {
              name: 'Private' as const
            }
          : undefined
      }))
    ]
  }, [myGroups, lang])

  return (
    <>
      <NavigationMenu
        collapsed={{
          activePattern: '/groups*',
          href: '/groups',
          iconName: 'Groups',
          value: !open
        }}
        expandedItems={expandedItems}
        id={GROUPS_NAV_MENU_ID}
        items={items}
        loading={loading}
        onAdd={isAdmin ? () => setAddGroupDialogOpen(true) : undefined}
        title={t('global', 'groups')}
        toggleNavigationItem={(id) => {
          toggleNavigationItem(id)
        }}
      />
      {isAdmin ? (
        <AddGroupDialog
          onClose={() => setAddGroupDialogOpen(false)}
          open={addDialogOpen}
        />
      ) : null}
    </>
  )
}

export default ResourcesNavigation
